/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BranchReport } from './BranchReport';
import {
    BranchReportFromJSON,
    BranchReportFromJSONTyped,
    BranchReportToJSON,
    BranchReportToJSONTyped,
} from './BranchReport';

/**
 * 
 * @export
 * @interface BranchesReportResponse
 */
export interface BranchesReportResponse {
    /**
     * 
     * @type {Array<BranchReport>}
     * @memberof BranchesReportResponse
     */
    data: Array<BranchReport>;
}

/**
 * Check if a given object implements the BranchesReportResponse interface.
 */
export function instanceOfBranchesReportResponse(value: object): value is BranchesReportResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BranchesReportResponseFromJSON(json: any): BranchesReportResponse {
    return BranchesReportResponseFromJSONTyped(json, false);
}

export function BranchesReportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BranchesReportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BranchReportFromJSON)),
    };
}

export function BranchesReportResponseToJSON(json: any): BranchesReportResponse {
    return BranchesReportResponseToJSONTyped(json, false);
}

export function BranchesReportResponseToJSONTyped(value?: BranchesReportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BranchReportToJSON)),
    };
}

